module.exports = function() {
  return new Worker(__webpack_public_path__ + "83288de20d15134a091b.worker.js");
};